function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_59670",
  "data-name": "Path 59670",
  d: "M0,0H24V24H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_59671",
  "data-name": "Path 59671",
  d: "M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm1.41,16.09v.58A1.336,1.336,0,0,1,12.08,20h-.01a1.336,1.336,0,0,1-1.33-1.33v-.6a3.966,3.966,0,0,1-3.01-2.24.851.851,0,0,1,.8-1.16h.24a.888.888,0,0,1,.81.6c.29.75,1.05,1.27,2.51,1.27,1.96,0,2.4-.98,2.4-1.59,0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67,0-1.72,1.39-2.84,3.11-3.21v-.6A1.336,1.336,0,0,1,12.08,4h.01a1.336,1.336,0,0,1,1.33,1.33v.62a3.559,3.559,0,0,1,2.63,2.26.85.85,0,0,1-.81,1.13h-.26a.809.809,0,0,1-.77-.62c-.23-.76-.86-1.25-2.12-1.25-1.5,0-2.4.68-2.4,1.64,0,.84.65,1.39,2.67,1.91s4.18,1.39,4.18,3.91c-.02,1.83-1.39,2.83-3.13,3.16Z"
});

function SvgMonetization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "monetization_on_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonetization);
export default __webpack_public_path__ + "static/media/monetization.df96086d.svg";
export { ForwardRef as ReactComponent };